import { Container } from '@mui/system';

function Footer() {
    return (
      <Container>
        <footer>
          <div className="container">
            &copy;2022 - WiKi
          </div>
        </footer>
      </Container>
    );
  }
  
  export default Footer;